import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/system-setting',
    name: 'SystemSetting',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/system-setting/staff-manage/list',
    meta: {
      title: '系统设置',
    },
    children: [
      {
        path: 'file-manage/list',
        name: 'SystemSettingFileManage',
        component: () => import('./file-manage/views/list/index.vue'),
        meta: {
          title: '上传管理',
          auth: true,
          activeMenu: 'SystemSettingFileManage',
        },
      },
      {
        path: 'file-manage/detail/:id',
        name: 'SystemSettingFileManageDetail',
        component: () => import('./file-manage/views/detail/index.vue'),
        meta: {
          title: '上传详情',
          auth: true,
          activeMenu: 'SystemSettingFileManage',
        },
      },
      {
        path: 'template-library-manage/list',
        name: 'SystemSettingTemplateLibraryManage',
        component: () => import('./template-library-manage/views/list/index.vue'),
        meta: {
          title: '版型库管理',
          auth: true,
          activeMenu: 'SystemSettingTemplateLibraryManage',
        },
      },
      {
        path: 'template-library-manage/pattern-create',
        name: 'SystemSettingTemplateLibraryManagePatternCreate',
        component: () => import('./template-library-manage/views/pattern-create/index.vue'),
        meta: {
          title: '版型库新增',
          auth: true,
          activeMenu: 'SystemSettingTemplateLibraryManage',
        },
      },
      {
        path: 'template-library-manage/pattern-edit/:templateId',
        name: 'SystemSettingTemplateLibraryManagePatternEdit',
        component: () => import('./template-library-manage/views/pattern-create/index.vue'),
        meta: {
          title: '版型库编辑',
          auth: true,
          activeMenu: 'SystemSettingTemplateLibraryManage',
        },
      },
    ],
  },
] as IRouteConfig[];
